import { confirmAlert } from 'react-confirm-alert';

import { LastFaceDeleteConfirmation } from './ui/LastFaceDeleteConfirmation';

export interface ConfirmLastFaceDeletionProps {
  onConfirm: VoidFunction;
  onReject?: VoidFunction;
  async?: boolean;
}

export const confirmLastFaceDeletion = ({
  onConfirm,
  onReject = undefined,
  async = false,
}: ConfirmLastFaceDeletionProps): void | Promise<void> => {
  /*
   Добавить сюда:
   - логику открепления карточки от всех списков после удаления последнего лица, когда бек доработает списки карточек
   Сейчас:
   - карточка не имеет своих списков, а списки карточки выводятся по спискам первого лица
   - после удаления последнего лица в карточке - карточка автоматически открепляется от всех списков
   */

  const buildAlert = ($onConfirm?: VoidFunction, $onReject?: VoidFunction) => confirmAlert({
    customUI: ({ onClose }) => {
      return (
        <LastFaceDeleteConfirmation
          onConfirm={() => {
            $onConfirm?.();
            onClose();
          }}
          onReject={() => {
            $onReject?.();
            onClose();
          }}

        />
      );
    },
  });

  if (!async) return void buildAlert(onConfirm, onReject);

  return new Promise((resolve, reject) => {
    const $onConfirm = () => {
      onConfirm?.();
      resolve();
    };
    const $onReject = () => {
      onReject?.();
      reject();
    };
    buildAlert($onConfirm, $onReject);
  });
};
